// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xovi-","title":"styles_title__oUYEd"};